import { render, staticRenderFns } from "./FailedDeliveryPerform.vue?vue&type=template&id=154ef6e9&scoped=true"
import script from "./FailedDeliveryPerform.vue?vue&type=script&lang=js"
export * from "./FailedDeliveryPerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ef6e9",
  null
  
)

export default component.exports